import { RefObject } from 'react';
import i18n from 'i18next';

import * as notificationActions from '@/components/notification/Actions';
import { FRONTEND_URL } from '@/services/Constants';
import { store } from '@/store';

export const copyToClipboard = (
	inputField: RefObject<HTMLInputElement | null>,
	type: 'copy' | 'link',
): boolean | undefined => {
	if (!inputField.current) return;
	const { value } = inputField.current;
	const copyText = type === 'copy' ? value : `${FRONTEND_URL}/${value}`;

	// Legacy IE clipboard API
	if ((window as any).clipboardData && (window as any).clipboardData.setData) {
		return (window as any).clipboardData.setData('Profile link', copyText);
	}

	const copyField = document.createElement('input');
	document.body.appendChild(copyField);
	copyField.setAttribute('id', 'copyField');
	(document.getElementById('copyField') as HTMLInputElement).value = copyText;
	copyField.select();

	try {
		document.execCommand('copy');
		document.body.removeChild(copyField);
		store.dispatch(
			notificationActions.createNotification(
				i18n.t('notifications.copied_to_clipboard_notification') as string,
				null,
				false,
				3000,
			),
		);
	} catch (e) {
		window.prompt(i18n.t('notifications.copied_to_clipboard') as string, copyText);
		document.body.removeChild(copyField);
	}
};
